import {
    // SET_USER_ORG,
    GET_ORG_KIOSKS_SUCCESS,
    GET_ORG_KIOSKS_FAILURE,
    GET_ORG_PANELS,
    GET_ORG_PANELS_SUCCESS,
    GET_ORG_PANELS_FAILURE
} from '../actions/types';

const INITIAL_STATE = {
    // aggregatePanel: null,
    managerOrgsDevices: null,
    loadingManagerOrgsDevicesError: null,
    loadingOrgPanels: false,
    loadingOrgPanelsError: null,
    orgPanels: null,
    panelUsers: null
};

// const metricSummation = data => {
//     return {
//         online_panels: 227,
//         offline_panels: 2,
//         property_count: data.length,
//         active_units: data.reduce((n, { active_units }) => n + active_units, 0),
//         active_credentials: data.reduce((n, { credentials }) => n + credentials, 0)
//     };
// };

const orgReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        // case SET_USER_ORG:
        //     return {
        //         ...state,
        //         aggregatePanel: metricSummation(action.payload.orgs)
        //     };
        case GET_ORG_KIOSKS_SUCCESS:
            return {
                ...state,
                managerOrgsDevices: action.payload,
                loadingManagerOrgsDevicesError: null
            };
        case GET_ORG_KIOSKS_FAILURE:
            return {
                ...state,
                loadingManagerOrgsDevicesError: action.payload
            };
        case GET_ORG_PANELS:
            return {
                ...state,
                loadingOrgPanels: true,
                loadingOrgPanelsError: null,
                orgPanels: null,
                panelUsers: null
            };
        case GET_ORG_PANELS_SUCCESS:
            return {
                ...state,
                orgPanels: action.payload.panels,
                panelUsers: action.payload.panelUsers,
                loadingOrgPanelsError: null,
                loadingOrgPanels: false
            };
        case GET_ORG_PANELS_FAILURE:
            return {
                ...state,
                loadingOrgPanelsError: action.payload,
                loadingOrgPanels: false,
                orgPanels: null,
                panelUsers: null
            };
        default:
            return state;
    }
};

export default orgReducer;
